import { Box } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

const BaseAlertBox = Box.withConfig({
  marginBottom: '5',
  paddingY: '2',
  paddingX: '6',
  borderWidth: '1px',
  _text: {
    fontSize: '16px',
    textAlign: 'center',
  },
});

export const SuccessAlertBox = BaseAlertBox.withConfig({
  borderColor: primitive.$fieryRed,
  _text: {
    fontFamily: 'heading',
    color: primitive.$fieryRed,
  },
});

export const ErrorAlertBox = BaseAlertBox.withConfig({
  borderColor: primitive.$greyEight,
  _text: {
    color: primitive.$greyEight,
  },
});
